// src/components/forms/SurveyListArchivedItem.js
import React, { useState } from 'react';
import { MessageSquare, BarChart3, MoreVertical, RotateCcw } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import Button from './Button';

import API_CONFIG from '../../config/api'
const BASE_URL = API_CONFIG.BASE_URL;

// Expects surveyInfo (matching SurveyInfo Pydantic model) and refreshData function
function SurveyListArchivedItem({ surveyInfo, refreshData }) {
	const [dropdownOpen, setDropdownOpen] = useState(false);
	const surveyTitleDisplay = surveyInfo?.title || 'Untitled Survey';
	const navigate = useNavigate();

	const handleUnarchiveClick = () => {
		const confirmed = alert("Are you sure you want to unarchive this survey? It will be moved back to draft status.\nNot implemented yet");
		if (confirmed) {
			console.log(`Attempting to unarchive survey with ID: ${surveyInfo.survey_id}`);
		} else {
			console.log("Unarchive action cancelled.");
		}
	};

	const handleResponseClick = () => {
		console.log(`Navigating to responses for survey with ID: ${surveyInfo.survey_id}`);
		alert(`Response Not implemented yet`);
	};

	const handleAnalyticsClick = () => {
		console.log(`Navigating to analytics for survey with ID: ${surveyInfo.survey_id}`);
		alert(`Analytics Not implemented yet`);
	};

	const toggleDropdown = () => {
		setDropdownOpen(!dropdownOpen);
	};

	const closeDropdown = () => {
		setDropdownOpen(false);
	};

	return (
		<div className='border shadow-sm rounded-lg p-4 flex flex-col h-full relative bg-gray-50'>
			<div className='flex justify-between items-center'>
				<h2 className='text-lg font-semibold text-gray-700 flex-grow truncate'>{surveyTitleDisplay}</h2>
				<div className="flex items-center gap-1">
					<span className="px-2 py-1 bg-gray-200 text-gray-800 text-xs rounded-full">Archived</span>
				</div>
			</div>

			<h3 className='text-sm text-gray-500 mt-1 mb-4'>
				ID: {surveyInfo.survey_id} - Created: {new Date(surveyInfo.created_at).toLocaleDateString()}
			</h3>

			<hr className='my-2'></hr>

			{/* Action Buttons */}
			<div className='flex justify-between items-center mt-auto'>
				{/* Primary Actions - Most Important */}
				<div className='flex gap-2'>
					<Button
						onClick={handleResponseClick}
						variant="primary"
						className="flex gap-2 items-center px-3 py-1.5 bg-blue-500 text-white rounded text-sm hover:bg-blue-600 transition-colors"
					>
						<MessageSquare className='h-4 w-4'/> Responses
					</Button>

					<Button
						onClick={handleAnalyticsClick}
						variant="secondary"
						className="flex gap-2 items-center px-3 py-1.5 border rounded text-sm text-gray-700 hover:bg-gray-100 transition-colors"
					>
						<BarChart3 className='h-4 w-4'/> Analytics
					</Button>
				</div>

				{/* More Actions Dropdown */}
				<div className='relative'>
					<button
						onClick={toggleDropdown}
						className="flex items-center justify-center w-8 h-8 border rounded hover:bg-gray-100 transition-colors"
					>
						<MoreVertical className='h-4 w-4'/>
					</button>

					{dropdownOpen && (
						<>
							{/* Overlay to close dropdown when clicking outside */}
							<div
								className="fixed inset-0 z-10"
								onClick={closeDropdown}
							></div>
							
							{/* Dropdown Menu */}
							<div className="absolute right-0 mt-1 w-48 bg-white border rounded-md shadow-lg z-20">
								<div className="py-1">
									<button
										onClick={() => { handleUnarchiveClick(); closeDropdown(); }}
										className="w-full text-left px-4 py-2 text-sm text-green-700 hover:bg-green-50 flex items-center gap-2"
									>
										<RotateCcw className='h-4 w-4'/> Unarchive
									</button>
								</div>
							</div>
						</>
					)}
				</div>
			</div>
		</div>
	);
}

export default SurveyListArchivedItem;